import React, { useState } from 'react';
import axios from 'axios';
import { useData } from '../DataContext';

export default function CarsPage() {
  const { cars, setCars } = useData();
  const [selectedCar, setSelectedCar] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [priceInput, setPriceInput] = useState('');
  const [addPriceInput, setAddPriceInput] = useState('');

  const token = localStorage.getItem('token');
  const apiUrl = process.env.REACT_APP_API_URL;
  const headers = { headers: { Authorization: `Bearer ${token}` } };

  // формат цены
  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';
    const num = Number(value);
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }

  // добавление машины
  async function handleAddCar(e) {
    e.preventDefault();
    try {
      const form = e.target;
      const rawPrice = (form.pricePerDay.value || '').replace(/\s/g, '').replace(',', '.');
      const parsedPrice = parseFloat(rawPrice);
      if (isNaN(parsedPrice)) {
        alert('Введите корректную цену');
        return;
      }

      const data = {
        name: form.name.value.trim(),
        number: form.number.value.trim(),
        pricePerDay: parsedPrice,
        status: 'available',
      };

      const res = await axios.post(`${apiUrl}/api/cars`, data, headers);
      setCars(prev => [...prev, res.data]);

      form.reset();
      setAddPriceInput('');
      setAddMode(false);
    } catch (err) {
      console.error(err);
      alert('Ошибка при добавлении машины');
    }
  }

  // редактирование машины
  async function handleUpdateCar(e) {
    e.preventDefault();
    try {
      if (!selectedCar) return;

      const form = e.target;
      const rawPrice = (form.pricePerDay.value || '').replace(/\s/g, '').replace(',', '.');
      const parsedPrice = parseFloat(rawPrice);
      if (isNaN(parsedPrice)) {
        alert('Введите корректную цену');
        return;
      }

      const payload = {
        name: form.name.value.trim(),
        number: form.number.value.trim(),
        pricePerDay: parsedPrice,
      };

      const res = await axios.put(`${apiUrl}/api/cars/${selectedCar._id}`, payload, headers);
      setCars(prev => prev.map(c => (c._id === selectedCar._id ? res.data : c)));

      setEditMode(false);
      setSelectedCar(null);
      setPriceInput('');
    } catch (err) {
      console.error(err);
      alert('Ошибка при сохранении');
    }
  }

  return (
    <div className="space-y-5">
      {/* Заголовок */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-xl font-semibold">Машины</h1>
        <button
          onClick={() => setAddMode(true)}
          className="bg-emerald-600 hover:bg-emerald-700 px-4 py-2 rounded transition-all"
        >
          Добавить машину
        </button>
      </div>

      {/* Сетка машин */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {cars.map((c) => (
          <div
            key={c._id}
            onClick={() => {
              setSelectedCar(c);
              setPriceInput(formatMoney(c.pricePerDay));
            }}
            className="bg-zinc-900 rounded-lg p-4 hover:bg-zinc-800 cursor-pointer transition-all"
          >
            <div className="text-lg font-medium">{c.name}</div>
            <div className="text-zinc-400">{c.number}</div>
            <div className="mt-2">{formatMoney(c.pricePerDay)} / Час</div>
            <div className="mt-2 text-sm text-zinc-500">
              Статус: <span className="text-zinc-300">{c.status}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Информация о машине */}
      {selectedCar && !editMode && (
        <Modal onClose={() => setSelectedCar(null)}>
          <h2 className="text-lg font-semibold mb-4">Информация о машине</h2>
          <p><b>Название:</b> {selectedCar.name}</p>
          <p><b>Номер:</b> {selectedCar.number}</p>
          <p><b>Цена за день:</b> {formatMoney(selectedCar.pricePerDay)}</p>
          <p><b>Статус:</b> {selectedCar.status}</p>

          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => setEditMode(true)}
              className="bg-blue-600 hover:bg-blue-700 px-3 py-2 rounded"
            >
              Изменить
            </button>
            <button
              onClick={() => setSelectedCar(null)}
              className="bg-zinc-700 hover:bg-zinc-600 px-3 py-2 rounded"
            >
              Закрыть
            </button>
          </div>
        </Modal>
      )}

      {/* Редактирование */}
      {editMode && selectedCar && (
        <Modal onClose={() => setEditMode(false)}>
          <h2 className="text-lg font-semibold mb-4">Изменить машину</h2>
          <form onSubmit={handleUpdateCar} className="space-y-3">
            <input
              name="name"
              defaultValue={selectedCar.name}
              placeholder="Название"
              className="w-full p-2 rounded bg-zinc-800"
              required
            />
            <input
              name="number"
              defaultValue={selectedCar.number}
              placeholder="Номер"
              className="w-full p-2 rounded bg-zinc-800"
              required
            />
            <input
              name="pricePerDay"
              type="text"
              placeholder="Цена за день"
              value={priceInput}
              onChange={(e) =>
                setPriceInput(e.target.value.replace(/[^\d.,\s]/g, ''))
              }
              onBlur={() => {
                const clean = priceInput.replace(/\s/g, '').replace(',', '.');
                if (!isNaN(clean) && clean !== '') {
                  setPriceInput(formatMoney(Number(clean)));
                }
              }}
              className="w-full p-2 rounded bg-zinc-800"
              required
            />
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => { setEditMode(false); setSelectedCar(null); setPriceInput(''); }}
                className="bg-zinc-700 hover:bg-zinc-600 px-3 py-2 rounded"
              >
                Назад
              </button>
              <button
                type="submit"
                className="bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded"
              >
                Сохранить
              </button>
            </div>
          </form>
        </Modal>
      )}

      {/* Добавление */}
      {addMode && (
        <Modal onClose={() => setAddMode(false)}>
          <h2 className="text-lg font-semibold mb-4">Добавить машину</h2>
          <form onSubmit={handleAddCar} className="space-y-3">
            <input
              name="name"
              type="text"
              placeholder="Название"
              className="w-full p-2 rounded bg-zinc-800"
              required
            />
            <input
              name="number"
              type="text"
              placeholder="Номер"
              className="w-full p-2 rounded bg-zinc-800"
              required
            />
            <input
              name="pricePerDay"
              type="text"
              placeholder="Цена за день"
              value={addPriceInput}
              onChange={(e) =>
                setAddPriceInput(e.target.value.replace(/[^\d.,\s]/g, ''))
              }
              onBlur={() => {
                const clean = addPriceInput.replace(/\s/g, '').replace(',', '.');
                if (!isNaN(clean) && clean !== '') {
                  setAddPriceInput(formatMoney(Number(clean)));
                }
              }}
              className="w-full p-2 rounded bg-zinc-800"
              required
            />
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setAddMode(false)}
                className="bg-zinc-700 hover:bg-zinc-600 px-3 py-2 rounded"
              >
                Назад
              </button>
              <button
                type="submit"
                className="bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded"
              >
                Сохранить
              </button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

// 🔸 Универсальный компонент модалки
function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-zinc-900 p-6 rounded-2xl w-full max-w-md shadow-xl">
        {children}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-zinc-400 hover:text-white"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
